
  (function () {
    console.log("[mc-packaging] loaded (D: attributes-only)");

    // =========================
    // CONFIG
    // =========================
    const CONFIG = {
      currencySymbol: "$",
      currencyCode: "USD",
      // Cart attributes (will sync to order "Additional details" / attributes)
      attrKey: "mc_packaging_key",
      attrTitle: "mc_packaging_title",
      attrImage: "mc_packaging_image",
      attrNotice: "mc_packaging_notice",

      // Also sync packaging title into cart note
      writeToNote: false,
      noteLinePrefix: "Packaging: ",


      options: [


              {
          key: "perfect_pink",
          title: "Perfect Box - Pink",
          subtitle: "Spring",
          thresholdCents: 35000,
          piecesText: "Fits 3+ pieces",
          image:
            "https://cdn.shopify.com/s/files/1/0937/4489/0204/files/20260220-1_430x.jpg",
        },
              {
          key: "perfect_blue",
          title: "Perfect Box - Blue",
          subtitle: "Spring",
          thresholdCents: 35000,
          piecesText: "Fits 3+ pieces",
          image:
            "https://cdn.shopify.com/s/files/1/0937/4489/0204/files/20260220-10_430x.jpg",
        },


        {
          key: "garden_pink",
          title: "Monet Garden Box - Pink",
          subtitle: "Favorite",
          thresholdCents: 30000,
          piecesText: "Fits 3+ pieces",
          image:
            "https://cdn.shopify.com/s/files/1/0937/4489/0204/files/img_v3_02th_e16b35f2-f679-42ce-9b78-496ad631549g_430x.jpg",
        },
        {
          key: "garden_purple",
          title: "Monet Garden Box - Purple",
          subtitle: "Favorite",
          thresholdCents: 30000,
          piecesText: "Fits 3+ pieces",
          image:
            "https://cdn.shopify.com/s/files/1/0937/4489/0204/files/img_v3_02th_0e88d04d-e8c9-4b80-945c-af51ecf9df9g_430x.jpg?v=1767489306",
        },
        {
          key: "rose",
          title: "Rose Box",
          subtitle: "Romantic",
          thresholdCents: 30000,
          piecesText: "Fits 3+ pieces",
          image:
            "https://cdn.shopify.com/s/files/1/0937/4489/0204/files/img_v3_02u0_7548520e-9226-4862-891d-5a32da6e264g_430x.jpg?v=1768678903",
        },
      ],
    };

    // =========================
    // DOM helpers
    // =========================
    const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
    const $ = (sel, root = document) => root.querySelector(sel);

  function money(cents) {
    return `${CONFIG.currencySymbol}${(Number(cents || 0) / 100).toFixed(2)} ${CONFIG.currencyCode}`;
  }

    function escapeHtml(str) {
      return String(str || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    // =========================
    // Cart state (cache)
    // =========================
  let CART_CACHE = null;
  let CART_FETCHING = null;

  async function fetchCart(force = false) {
    if (!force && CART_CACHE) return CART_CACHE;
    if (!force && CART_FETCHING) return CART_FETCHING;

    CART_FETCHING = fetch("/cart.js", {
      credentials: "same-origin",
      cache: "no-store",
    })
      .then((res) => res.json())
      .then((cart) => {
        CART_CACHE = cart;
        return cart;
      })
      .finally(() => {
        CART_FETCHING = null;
      });

    return CART_FETCHING;
  }

    function calcItemsSubtotalCents(cart) {
      return (cart.items || []).reduce((sum, item) => sum + (item.final_line_price || 0), 0);
    }

    async function cartUpdate(payload) {
      const res = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify(payload),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data?.description || "cartUpdate failed");
      CART_CACHE = data; // /cart/update.js returns full cart
      return data;
    }

    // =========================
    // Note line utilities (optional)
    // =========================
    function upsertNoteLine(note, linePrefix, lineValue) {
      const raw = String(note || "");
      const lines = raw ? raw.split(/\r?\n/) : [];
      const prefix = String(linePrefix || "");
      const nextLines = [];

      let replaced = false;
      for (const l of lines) {
        if (prefix && l.startsWith(prefix)) {
          // replace this one
          if (lineValue) nextLines.push(prefix + lineValue);
          replaced = true;
        } else {
          nextLines.push(l);
        }
      }

      if (!replaced && lineValue) nextLines.push(prefix + lineValue);

      // trim trailing blank lines
      while (nextLines.length && nextLines[nextLines.length - 1].trim() === "") nextLines.pop();

      return nextLines.join("\n");
    }

    // =========================
    // UI helpers (support multiple snippet instances)
    // =========================
    function setNotice(msg) {
      $$("[data-mc-packaging-notice]").forEach((el) => {
        if (!msg) {
          el.hidden = true;
          el.textContent = "";
        } else {
          el.hidden = false;
          el.textContent = msg;
        }
      });
    }

    function setCurrentText(msg) {
      $$("[data-mc-packaging-current]").forEach((el) => {
        el.textContent = msg || "";
      });
    }

    function renderSelectedPreview(title, imageUrl, statusHtml) {
      $$("[data-mc-packaging-preview]").forEach((el) => {
        if (!title) {
          el.innerHTML = "";
          return;
        }

        const safeTitle = escapeHtml(title);
        const safeImg = imageUrl ? escapeHtml(imageUrl) : "";

        el.innerHTML = `
          <div class="mc-packaging-preview">
            ${
              safeImg
                ? `<img class="mc-packaging-preview__img" src="${safeImg}" alt="${safeTitle}" loading="lazy">`
                : ""
            }
            <div class="mc-packaging-preview__content">
              <div class="mc-packaging-preview__t">${safeTitle}</div>
              ${statusHtml || ""}
            </div>
          </div>
        `;
      });
    }

    // =========================
    // Modal helpers (multiple snippet instances)
    // =========================
    function findRootFromClick(target) {
      return target.closest("[data-mc-packaging-root]") || document;
    }

    function getModalWithinRoot(root) {
      const modal = $("[data-mc-packaging-modal]", root);
      return modal || null;
    }

    function ensureModalInBody(modal) {
      if (!modal) return null;
      if (modal.parentElement !== document.body) document.body.appendChild(modal);
      return modal;
    }

    function isModalOpen(modal) {
      if (!modal) return false;
      if (modal.hasAttribute("hidden")) return false;
      if (getComputedStyle(modal).display === "none") return false;
      return true;
    }

    function openModalFromRoot(root) {
      const modal = getModalWithinRoot(root);
      if (!modal) return;

      ensureModalInBody(modal);

      document.body.classList.add("mc-packaging--open");
      modal.removeAttribute("hidden");
      modal.style.display = "block";
      document.body.style.overflow = "hidden";

      // fast UI refresh from cache
      refreshPackagingUI(modal).catch(() => {});
    }

    function closeModal(modal) {
      if (!modal) return;
      document.body.classList.remove("mc-packaging--open");
      modal.setAttribute("hidden", "");
      modal.style.display = "none";
      document.body.style.overflow = "";
      setNotice("");
    }

    // =========================
    // Rendering
    // =========================
    function buildMeta(opt) {
      const pieces = opt.piecesText ? ` • ${opt.piecesText}` : "";
      if (opt.thresholdCents && opt.thresholdCents > 0) {
        return `Unlocks at ${money(opt.thresholdCents)}${pieces}`;
      }
      return pieces ? pieces.replace(/^ • /, "") : "";
    }


      function getSelectedOption(cart) {
      const selectedKey = (cart.attributes && cart.attributes[CONFIG.attrKey]) || "";
      return CONFIG.options.find((o) => String(o.key) === String(selectedKey)) || null;
    }

    function isOptionQualified(opt, subtotal) {
      if (!opt) return true;
      return subtotal >= (opt.thresholdCents || 0);
    }

      function getDesiredNotice(opt, subtotal) {
      if (!opt) return "";
      if (subtotal >= (opt.thresholdCents || 0)) return "";
      return "Your selected box is not available for this order total. A more suitable packaging option will be used instead.";
    }

    async function syncPackagingNoticeFromCart(cartInput) {
      const cart = cartInput || await fetchCart(true);
      const subtotal = calcItemsSubtotalCents(cart);

      const selectedOpt = getSelectedOption(cart);
      if (!selectedOpt) {
        const currentNotice = (cart.attributes && cart.attributes[CONFIG.attrNotice]) || "";
        if (!currentNotice) return cart;

        const updatedCart = await cartUpdate({
          attributes: {
            [CONFIG.attrNotice]: "",
          },
        });
        return updatedCart;
      }

      const desiredNotice = getDesiredNotice(selectedOpt, subtotal);
      const currentNotice = (cart.attributes && cart.attributes[CONFIG.attrNotice]) || "";

      if (currentNotice === desiredNotice) {
        return cart;
      }

      const updatedCart = await cartUpdate({
        attributes: {
          [CONFIG.attrNotice]: desiredNotice,
        },
      });

      return updatedCart;
    }


    function cardHTML(opt, state) {
      const locked = state.subtotal < (opt.thresholdCents || 0);
      const selected = String(state.selectedKey || "") === String(opt.key);
      const meta = buildMeta(opt);

      return `
        <div class="mc-packaging-card ${locked ? "is-locked" : ""}" data-key="${escapeHtml(opt.key)}">
          <img class="mc-packaging-card__img" src="${escapeHtml(opt.image || "")}" alt="${escapeHtml(opt.title || "")}" loading="lazy">
          <div class="mc-packaging-card__mid">
            <div class="mc-packaging-card__t">${escapeHtml(opt.title || "")}</div>
            <div class="mc-packaging-card__s">${escapeHtml(opt.subtitle || "")}</div>
            <div class="mc-packaging-card__meta">${escapeHtml(meta || "")}</div>
          </div>
          <div class="mc-packaging-card__right">
            <div class="mc-packaging-card__price">FREE</div>
            <button
              type="button"
              class="mc-packaging-card__btn ${selected ? "" : "primary"}"
              data-mc-packaging-action
              data-key="${escapeHtml(opt.key)}"
              ${locked && !selected ? "disabled" : ""}
            >${selected ? "Remove" : "Add"}</button>
          </div>
        </div>
      `;
    }

    // =========================
    // Core action (D)
    // =========================
    async function selectPackagingByKey(key) {
  const cart = await fetchCart(true);
      const subtotal = calcItemsSubtotalCents(cart);

      const opt = CONFIG.options.find((o) => String(o.key) === String(key));
      if (!opt) return cart;

      const curKey = (cart.attributes && cart.attributes[CONFIG.attrKey]) || "";
      const isCurrentlySelected = String(curKey) === String(opt.key);

      // threshold check
      if (!isCurrentlySelected && (opt.thresholdCents || 0) > 0 && subtotal < opt.thresholdCents) {
        const diff = opt.thresholdCents - subtotal;
        setNotice(`Unlocks at ${money(opt.thresholdCents)}. Add ${money(diff)} more to unlock ✨`);
        return cart;
      }

      setNotice("");

      const nextAttrs = {};

  if (isCurrentlySelected) {
    nextAttrs[CONFIG.attrKey] = "";
    nextAttrs[CONFIG.attrTitle] = "";
    nextAttrs[CONFIG.attrImage] = "";
    nextAttrs[CONFIG.attrNotice] = "";
  } else {
    nextAttrs[CONFIG.attrKey] = opt.key;
    nextAttrs[CONFIG.attrTitle] = opt.title || "";
    nextAttrs[CONFIG.attrImage] = opt.image || "";
    nextAttrs[CONFIG.attrNotice] = getDesiredNotice(opt, subtotal);
  }

  const updatedCart = await cartUpdate({
    attributes: nextAttrs,
  });

      return updatedCart;
    }

    // =========================
    // UI sync (NO section refresh)
    // =========================

      async function refreshPackagingUI(modalOrNull) {
      const cart = await fetchCart(true);
      const subtotal = calcItemsSubtotalCents(cart);

      const selectedKey = (cart.attributes && cart.attributes[CONFIG.attrKey]) || "";
      const selectedTitle = (cart.attributes && cart.attributes[CONFIG.attrTitle]) || "";
      const selectedImage = (cart.attributes && cart.attributes[CONFIG.attrImage]) || "";

      const selectedOpt = getSelectedOption(cart);
      const selectedQualified = isOptionQualified(selectedOpt, subtotal);

      if (selectedKey && selectedTitle) {
        if (selectedQualified) {
          setCurrentText("Selected packaging");
          renderSelectedPreview(
            selectedTitle,
            selectedImage,
            `<div class="mc-packaging-preview__status is-valid">Available for your current order</div>`
          );
        } else {
          const diff = (selectedOpt.thresholdCents || 0) - subtotal;

          setCurrentText("Selected packaging");

          renderSelectedPreview(
            selectedTitle,
            selectedImage,
            `
              <div class="mc-packaging-preview__status is-invalid">
                <div class="mc-packaging-preview__status-title">Currently unavailable</div>
                <div class="mc-packaging-preview__status-text">
                  Available from ${money(selectedOpt.thresholdCents)}<br>
                  Add ${money(diff)} more to keep this box.<br>
                  Otherwise, we’ll choose a more suitable box for your order.
                </div>
              </div>
            `
          );
        }
      } else {
        setCurrentText("If no selection is made, we’ll choose the most suitable one for you.");
        renderSelectedPreview("", "", "");
      }

      const modal = modalOrNull && modalOrNull.nodeType === 1 ? modalOrNull : null;
      if (!modal || !isModalOpen(modal)) return;

      if (selectedOpt && !selectedQualified) {
        const diff = (selectedOpt.thresholdCents || 0) - subtotal;
        setNotice(
          `${selectedOpt.title} is currently unavailable for this order. Add ${money(diff)} more to keep it, or we’ll choose a more suitable box.`
        );
      } else {
        setNotice("");
      }

      CONFIG.options.forEach((opt) => {
        const row = modal.querySelector(`.mc-packaging-card[data-key="${CSS.escape(opt.key)}"]`);
        if (!row) return;

        const btn = row.querySelector("[data-mc-packaging-action]");
        if (!btn) return;

        const locked = subtotal < (opt.thresholdCents || 0);
        const isSelected = String(selectedKey) === String(opt.key);
        const selectedButInvalid = isSelected && !isOptionQualified(opt, subtotal);

        if (selectedButInvalid) {
          btn.textContent = "Selected";
        } else {
          btn.textContent = isSelected ? "Remove" : "Add";
        }

        btn.classList.toggle("primary", !isSelected);
        btn.disabled = !!(locked && !isSelected);
        row.classList.toggle("is-locked", locked);
        row.classList.toggle("is-selected-invalid", selectedButInvalid);
      });
    }

    // =========================
    // Mount (render list once per modal instance)
    // =========================
    function mountModal(modal) {
      if (!modal) return;
      const list = $("[data-mc-packaging-list]", modal);
      if (!list) return;

      // prevent re-rendering list repeatedly
      if (list.dataset.mcRendered === "1") return;
      list.dataset.mcRendered = "1";

      // render quickly after cart cache ready
  fetchCart(true)
    .then((cart) => {
          const subtotal = calcItemsSubtotalCents(cart);
          const selectedKey = (cart.attributes && cart.attributes[CONFIG.attrKey]) || "";

          list.innerHTML = CONFIG.options
            .map((opt) => cardHTML(opt, { subtotal, selectedKey }))
            .join("");

          return refreshPackagingUI(modal);
        })
        .catch((e) => {
          console.error("[mc-packaging] mount failed", e);
          setNotice("Sorry, packaging options failed to load. Please refresh the cart.");
        });
    }

    // =========================
    // Single delegated binding
    // =========================
    (function bindDelegation() {
      if (window.__mcPackagingDelegatedD) return;
      window.__mcPackagingDelegatedD = true;

      document.addEventListener(
        "click",
        async (e) => {
          // OPEN
          const openBtn = e.target.closest("[data-mc-packaging-open]");
          if (openBtn) {
            e.preventDefault();
            const root = findRootFromClick(openBtn);
            const modal = getModalWithinRoot(root);
            if (!modal) return;

            // render list only once
            mountModal(modal);

            // open
            openModalFromRoot(root);
            return;
          }

          // CLOSE (works for any modal moved to body)
          const closeBtn = e.target.closest("[data-mc-packaging-close]");
          if (closeBtn) {
            e.preventDefault();
            const modal = e.target.closest("[data-mc-packaging-modal]") || null;
            if (modal) closeModal(modal);
            return;
          }

          // ACTION
          const actionBtn = e.target.closest("[data-mc-packaging-action]");
          if (!actionBtn) return;

          e.preventDefault();
          if (actionBtn.disabled) return;

          const modal = actionBtn.closest("[data-mc-packaging-modal]") || null;
          actionBtn.disabled = true;

          try {
            const key = actionBtn.getAttribute("data-key");
            await selectPackagingByKey(key);

            // fast update from cache
            await refreshPackagingUI(modal);
          } catch (err) {
            console.error("[mc-packaging] update failed", err);
            setNotice("Sorry, we couldn't update your packaging. Please refresh and try again.");
          } finally {
            actionBtn.disabled = false;
          }
        },
        true
      );
    })();

    // =========================
    // Init
    // =========================
    document.addEventListener("DOMContentLoaded", () => {
      // warm cache once (reduces “first open modal” delay)
  fetchCart(true)
    .then(() => refreshPackagingUI(null))
        .catch((e) => console.error("[mc-packaging] init failed", e));
    });

    // Optional: if Sense theme pubsub exists, update cache from cartUpdate events (no extra fetch)
      try {
      if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS === "object" && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
          if (event && event.cartData) {
            CART_CACHE = event.cartData;

            try {
              CART_CACHE = await syncPackagingNoticeFromCart(event.cartData);
            } catch (err) {
              console.error("[mc-packaging] sync notice failed", err);
            }

            refreshPackagingUI(null).catch(() => {});
          }
        });
      }
    } catch (e) {}
  })();


